import { useState, useEffect } from "react";
import { Calculator, Megaphone, HandCoins } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { workshopsContent } from "@/content/homepage";
import { supabase } from "@/integrations/supabase/client";

export const Workshops = ({
  onCtaClick
}: {
  onCtaClick?: () => void;
}) => {
  const iconMap = [Calculator, Megaphone, HandCoins];
  const [galleryImages, setGalleryImages] = useState<string[]>([]);

  useEffect(() => {
    const fetchGalleryImages = async () => {
      const { data } = await supabase
        .from("cms_homepage_workshops")
        .select("image_url")
        .eq("active", true)
        .order("display_order", { ascending: true });
      
      if (data) {
        setGalleryImages(data.map(img => img.image_url));
      }
    };

    fetchGalleryImages();
  }, []);

  const displayImages = galleryImages.length > 0 ? galleryImages : workshopsContent.images;

  return <section id="delavnice" className="py-20 md:py-28 bg-background">
      <div className="container mx-auto px-4">
        <div className="bg-secondary rounded-3xl p-8 md:p-12 lg:p-16 shadow-xl">
          <div className="max-w-4xl mx-auto text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">{workshopsContent.title}</h2>
            <p className="text-xl text-white/90">{workshopsContent.subtitle}</p>
          </div>

          {/* Carousel */}
          <div className="max-w-3xl mx-auto mb-12">
            <Carousel className="w-full">
              <CarouselContent>
                {displayImages.map((image, index) => <CarouselItem key={index}>
                    <div className="relative aspect-square md:aspect-video overflow-hidden rounded-2xl">
                      <img src={image} alt={`Delavnica ${index + 1}`} className="w-full h-full object-cover" loading="lazy" />
                    </div>
                  </CarouselItem>)}
              </CarouselContent>
              <CarouselPrevious className="left-4 bg-white/90 hover:bg-white" />
              <CarouselNext className="right-4 bg-white/90 hover:bg-white" />
            </Carousel>
          </div>
          
          <div className="grid gap-8 md:grid-cols-3 max-w-5xl mx-auto mb-10">
            {workshopsContent.workshops.map((workshop, index) => {
              const Icon = iconMap[index];
              return (
                <div key={index} className="text-center">
                  <div className="w-20 h-20 rounded-full bg-white/10 flex items-center justify-center mx-auto mb-6">
                    <Icon className="w-10 h-10 text-white" />
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-4">{workshop.title}</h3>
                  <p className="text-lg text-white/80">{workshop.description}</p>
                </div>
              );
            })}
          </div>

          <div className="text-center">
            <Button size="lg" onClick={onCtaClick} className="text-white hover:opacity-90 shadow-lg hover:shadow-xl h-12 px-8 text-base rounded-full transition-opacity" style={{ backgroundColor: '#7B1E3C' }}>
              {workshopsContent.ctaButton}
            </Button>
            <div className="mt-8 max-w-2xl mx-auto bg-white/10 backdrop-blur-md border-2 border-white/30 rounded-2xl p-6 animate-fade-in">
              <div className="flex items-center gap-4">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-white/20 flex items-center justify-center text-2xl">
                  {workshopsContent.discount.icon}
                </div>
                <p className="text-white text-lg leading-relaxed">
                  {workshopsContent.discount.text} <span className="inline-block px-3 py-1 rounded-lg font-bold text-lg" style={{ backgroundColor: '#7B1E3C', color: 'white' }}>{workshopsContent.discount.percentage}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};